/**
 * Base64 for an upload body.
 *
 * Chunked rather than a single spread: `String.fromCharCode(...bytes)` on a multi-megabyte
 * template blows the argument limit and throws RangeError, which reads to the operator as
 * "the upload failed" for a file that is perfectly fine.
 */
export async function toBase64(file: File): Promise<string> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}
